import { Task } from "../../types/Task";
import { TaskActionType } from "../actions/taskAction";

const initialState: Task[] = [];

const taskReducer = (state = initialState, action: any): Task[] => {
  switch (action.type) {
    case TaskActionType.FETCH_TASKS:
      return action.data;
    case TaskActionType.ADD_TASK:
      return [...state, action.data];
    case TaskActionType.EDIT_TASK:
      return state.map((task) =>
        task.id === action.data.id ? action.data : task,
      );
    case TaskActionType.DELETE_TASK:
      return state.filter((task) => task.id !== action.data);
    default:
      return state;
  }
};
export default taskReducer;
